import BasicServer from '~/services/BasicServer'
import { NetCode } from '~/types/const'
import store from '~/store'
import type { IHomePageConfig, ILanguage } from '~/services/BasicServer/types'
import { findKey, convertLanguage } from '~/utils'
export interface languageModel {
    code: string;
    name: string;
    lock: boolean;
}

const useBasicStore = defineStore('basic', () => {
    const homePageConfig = ref<IHomePageConfig>({} as IHomePageConfig)
    const isChina = ref(true)
    const languages = ref<ILanguage[]>([])
    const commonLanguages = ref<string[]>([])
    const languagesMap = ref<Record<string, string>>({})
    const localtionData = ref('')
    async function getHomePageConfig() {
        const res = await BasicServer.getHomePageConfig()
        if(res.code === NetCode.SUCCESS){
            await nextTick()
            homePageConfig.value = res.data as IHomePageConfig
        }
    }
    async function getLanguages() {
        const res = await BasicServer.getLanguages()
        if(res.code === NetCode.SUCCESS){
            await nextTick()
            let lan = (navigator.browserLanguage || navigator.language)
            let lanCode = findKey(convertLanguage, lan) || 'en'
            let newList: [languageModel] = res.data.langList
            let currentObject = null
            for (let i = 0; i < newList.length; i++) {
                let language = newList[i]
                if (language.code == lanCode && !language.lock) {
                    // @ts-ignore
                    currentObject = language
                    newList.splice(i, 1)
                    break
                }
            }
            if (currentObject) {
                newList.unshift(currentObject)
            }
            languages.value = res.data.langList as ILanguage[]
            commonLanguages.value = res.data.userLangList || []
            let maps = {}
            for (let index = 0; index < languages.value.length; index++) {
                const element = languages.value[index];
                maps[element.code] = element
            }
            languagesMap.value = maps
        }
    }
    function setLocaltion(data) {
        localtionData.value = data
    }

    const isDesktop = ref(true);
    function setIsDesktop(value: boolean) {
        isDesktop.value = value
    }
    return {
        homePageConfig,
        getHomePageConfig,
        isChina,
        languages,
        commonLanguages,
        languagesMap,
        getLanguages,
        localtionData,
        setLocaltion,
        isDesktop,
        setIsDesktop
    }
})

export function useBasicStoreHook() {
    return useBasicStore(store)
}
export default useBasicStore